export default __webpack_public_path__ + "static/media/StandBy_159x150.6042f65e.png";